var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Icon } from "../../UI";
import React from 'react';
import { Field } from 'react-redux-form';
import { Translate } from "../../I18N";










export const MediaModalUploadFileButton = ({
  formModel,
  acceptedFileTypes,
  inputFileRef,
  handleFileInPublicForm,
  handleUploadButtonClicked,
  handleInputFileChange
}) => {
  const inputComponent = (fileFieldAction) => /*#__PURE__*/
  _jsx("div", { className: "upload-button" }, void 0, /*#__PURE__*/
  _jsx("button", { type: "button", onClick: handleUploadButtonClicked, className: "btn" }, void 0, /*#__PURE__*/
  _jsx(Icon, { icon: "cloud-upload-alt" }), "\xA0 ", /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Select from computer")
  ), /*#__PURE__*/
  React.createElement("input", {
    "aria-label": "fileInput",
    type: "file",
    onChange: fileFieldAction,
    style: { display: 'none' },
    ref: inputFileRef,
    accept: acceptedFileTypes }
  )
  );


  if (formModel === 'publicform') {
    return /*#__PURE__*/(
      _jsx(Field, {
        "aria-label": "fileInput",
        model: ".file",
        component: () => inputComponent(handleFileInPublicForm),
        type: "file" }
      ));

  }

  return inputComponent(handleInputFileChange);
};